import React from 'react'

const LoadingIndicator = () => {
  return (
    <div>
      <p>Loading</p>
    </div>
  )
}

export default LoadingIndicator
